import { useRef, useState } from "react";
import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

const MAX_RETRIES = 5;
export const useCheckoutStatus = (sessionId: string | null) => {
  const { apiClient } = useSalesyApiClient();

  const [maxRetriesReached, setMaxRetriesReached] = useState(false);
  const retryCountRef = useRef<number>(0);

  const fetchStatus = () => {
    retryCountRef.current++;
    return apiClient.payments.checkoutStatus({ checkoutSession: sessionId! });
  };

  const query = useQuery({
    queryKey: ["checkoutStatus"],
    queryFn: fetchStatus,
    enabled: !!sessionId,
    refetchInterval: (data) => {
      if (data?.state.data?.completed) {
        return false;
      }

      // If max retries reached, stop polling and set the flag
      if (retryCountRef.current >= MAX_RETRIES) {
        setMaxRetriesReached(true);
      }

      return 4000;
    },
    staleTime: 0,
  });

  return { ...query, maxRetriesReached };
};
